import React from "react";

import {
	doc,
	updateDoc
}
from "firebase/firestore";

import {
	db
}
from "../firebase/firebaseConfig";

import {
	useAuth
}
from "../contextos/AuthContext";

const CambioPerfil = ({

	perfilActivo,

	onCambio

}) => {

	const {
		usuario
	} = useAuth();

	const cambiarPerfil =
	async (nuevoPerfil)=>{

		if(
			!usuario
		)return;

		await updateDoc(

			doc(
				db,
				"usuarios",
				usuario.uid
			),

			{
				perfilActivo:
				nuevoPerfil
			}

		);

		if(
			onCambio
		){

			onCambio(
				nuevoPerfil
			);

		}

		window.location.reload();

	};

	return(

		<div
			style={{

				display:"flex",

				gap:"0.5rem",

				alignItems:"center"

			}}
		>

			<button

				onClick={()=>
					cambiarPerfil(
						"estudiante"
					)
				}

				disabled={
					perfilActivo==="estudiante"
				}

			>

				🎓 Estudiante

			</button>

			<button

				onClick={()=>
					cambiarPerfil(
						"profesor"
					)
				}

				disabled={
					perfilActivo==="profesor"
				}

			>

				👨‍🏫 Profesor

			</button>

		</div>

	);

};

export default CambioPerfil;